import { render } from "./VLoadingOverlay.vue?vue&type=template&id=2a5397ea"
import script from "./VLoadingOverlay.vue?vue&type=script&lang=js"
export * from "./VLoadingOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__